import React, { forwardRef } from 'react';
import Button from '@atlaskit/button';
import AddIcon from '@atlaskit/icon/glyph/add';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

type Props = {
	/**
	 * Event emitted when the issue create button is clicked.
	 */
	onClick: () => void;
};

export const IssueCreateButton = forwardRef<HTMLElement, Props>(({ onClick }, ref) => {
	const { formatMessage } = useIntl();
	return (
		<Box xcss={createButtonContainerStyles}>
			<Button
				ref={ref}
				iconBefore={<AddIcon label="" size="small" />}
				onClick={onClick}
				// We can't apply padding to the parent as that affects calculation of the base flex size of the
				// item. So we need to apply margin to the child instead https://www.w3.org/TR/css-flexbox-1/#line-sizing.
				/* eslint-disable-next-line jira/react/no-style-attribute */
				style={buttonStyles}
			>
				{formatMessage(messages.createButton)}
			</Button>
		</Box>
	);
});

const createButtonContainerStyles = xcss({
	flex: 1,
});

const buttonStyles = {
	marginLeft: token('space.300', '24px'),
};
